// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"42c67088","843":"1cd0072d"}[chunkId] + ".chunk.css";
};